<template>
  <nav class="navbar d-flex align-items-center h-100">
    <div class="d-flex align-items-center navbar__inner-content" :class="navigationIsOpen ? 'is-active' : ''">
      <div class=" hamburger hamburger--spin" :class="navigationIsOpen ? 'is-active' : ''" v-on:click="openNav()">
        <span class="hamburger-box">
            <span class="hamburger-inner"></span>
        </span>
      </div>

      <img src="@/assets/images/shiseido_logo_black.svg" class="logo img-fluid" v-if=" !navigationIsOpen ">
      <img src="@/assets/images/shiseido_logo_white.svg" class="logo img-fluid" v-if="windowWidth <= 768 || navigationIsOpen">

    </div>

    <div class="navbar__content d-flex justify-content-center flex-column" id="navbarNav" >
      <div class="nav__item" v-on:click="closeNav()" :class="discoverStatus[0] == 0 ? '' : ''">
        <router-link :to="{ name: 'pages', params: { kapitel:'01', id:'010' }}" >
          <div class="nav__item--name" v-html="$t('GLOBAL_MENU_01')">Introduction</div>
        </router-link>
      </div>
      <div class="nav__item" v-on:click="closeNav()" :class="discoverStatus[1] == 0 ? '' : ''">
        <router-link :to="{ name: 'pages', params: { kapitel:'02', id:'010' }}">
          <div class="nav__item--name" v-html="$t('GLOBAL_MENU_02')">All about eyes</div>
        </router-link>
      </div>
      <div class="nav__item" v-on:click="closeNav()" :class="discoverStatus[2] == 0 ? '' : ''">
        <router-link :to="{ name: 'pages', params: { kapitel:'03', id:'010' }}">
          <div class="nav__item--name" v-html="$t('GLOBAL_MENU_03')">Meet the experts</div>

        </router-link>
      </div>
      <div class="nav__item" v-on:click="closeNav()" :class="discoverStatus[3] == 0 ? '' : ''">
        <router-link :to="{ name: 'pages', params: { kapitel:'04', id:'010' }}">
          <div class="nav__item--name" v-html="$t('GLOBAL_MENU_04')">Technology</div>
        </router-link>
      </div>
      <div class="nav__item" v-on:click="closeNav()" :class="discoverStatus[4] == 0 ? '' : ''">
        <router-link :to="{ name: 'pages', params: { kapitel:'05', id:'010' }}">
          <div class="nav__item--name" v-html="$t('GLOBAL_MENU_05')">Selling</div>
        </router-link>
      </div>
      <div class="nav__item" v-on:click="closeNav()" :class="discoverStatus[5] == 0 ? '' : ''">
        <router-link :to="{ name: 'pages', params: { kapitel:'06', id:'010' }}">
          <div class="nav__item--name" v-html="$t('GLOBAL_MENU_06')">Quiz</div>
        </router-link>
      </div>
      <div class="nav__item--close">
        <div class="btn__close">
          <div class="btn__close-text text-uppercase font-24 font-medium" v-on:click="closeModule()" v-html="$t('GLOBAL_CLOSE')">
            close module
          </div>
          <div class="close__btn"></div>
        </div>
      </div>
      <div class="bg"></div>
    </div>
  </nav>
</template>

<script>
import {gsap, TimelineMax, CSSPlugin} from 'gsap/all'

gsap.registerPlugin(CSSPlugin)

export default {
  name: "Navigation",
  components: {},
  data() {
    return {
      sites: "",
      timeline: '',
      navigationIsOpen: false,
      windowWidth: 0,
      lang: "",
      country: "",
      discoverStatus: [1,0,0,0,0,0],
      moduleStatus: ""
    }
  },
  methods: {
    getKapitel(kapitel) {
      return "0" + kapitel;
    },
    openNav() {
      const trigger = document.querySelector('#navbarNav').classList

      this.navigationIsOpen = !this.navigationIsOpen;

      if (trigger.contains('show')) {
        //trigger.toggle('show')
        this.timelineReverse.restart()
      } else {
        trigger.add('show')
        this.timeline.restart()
      }
    },
    closeModule(){
      window.open('/'+ this.country + '_' + this.lang + '/brand-choice/' ,"_self")
      // window.open('/uk_en/brand-choice/' ,"_self")
    },
    closeNav() {
      this.navigationIsOpen = !this.navigationIsOpen;
      this.timelineReverse.restart()
    },
    reverseFunction() {
      document.querySelector('#navbarNav')
          .classList
          .toggle('show');
    }
  },
  created() {
    this.$store.watch(
            (state, getters) => getters.lang,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.lang = newValue;
            },
    );
    this.$store.watch(
            (state, getters) => getters.country,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.country = newValue
            },
    );
    this.$store.watch(
            (state, getters) => getters.moduleStatus,
            (newValue, oldValue) => {
              console.log(`Updating lang from ${oldValue} to ${newValue}`);
              this.moduleStatus = newValue;
              console.log(this.moduleStatus)
              for (let i = 0; i < this.moduleStatus.length; i++) {
                if(this.moduleStatus[i][0] == '01'){
                  this.discoverStatus[1] = 1;
                } else if(this.moduleStatus[i][0] == '02'){
                  this.discoverStatus[2] = 1;
                } else if(this.moduleStatus[i][0] == '03'){
                  this.discoverStatus[3] = 1;
                } else if(this.moduleStatus[i][0] == '04'){
                  this.discoverStatus[4] = 1;
                } else if(this.moduleStatus[i][0] == '05'){
                  this.discoverStatus[5] = 1;
                }

              }
            },
    );
  },
  beforeMount() {
    this.lang = this.$store.getters.lang;
    this.country = this.$store.getters.country;
  },
  mounted() {
    this.moduleStatus = this.$store.getters.moduleStatus;
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    this.timeline = new TimelineMax({
     /* onReverseComplete: function () {
        document.querySelector('#navbarNav')
            .classList
            .toggle('show');
      }*/
    })
    this.timeline.staggerFrom('.nav__item', 0.5, {xPercent: -100}, 0.1);
    this.timeline.fromTo('.nav__item--close', 0.5, {xPercent: -100, delay: -0.4}, {xPercent: 0, delay: -0.4});
    // this.timeline.from('.navbar__content', 0.5, {xPercent: 100, delay: -0.5});

    this.timelineReverse = new TimelineMax({paused:true
      /* onReverseComplete: function () {
         document.querySelector('#navbarNav')
             .classList
             .toggle('show');
       }*/
    })
    this.timelineReverse.add(function (){
      document.querySelector('#navbarNav')
          .classList
          .toggle('show');
    });
    this.timelineReverse.staggerFrom('.nav__item', 0.5, {xPercent: -100}, 0.2);
    this.timelineReverse.fromTo('.nav__item--close', 0.5, {xPercent: 0, delay: -0.4},{xPercent: -100, delay: -0.3});


  }

}
</script>

<style scoped>

</style>